/*
var module = angular.module('octopusApp.infrastructure');

module.provider('octoRoute', function OctoRoute() {
  this.redirect = function(getUrl) {
    return {
      templateUrl: 'areas/shared/views/redirect.html',
      title: 'Loading...',
      tab: '',
      controller: function($scope, $routeParams, $location, busy, octopusRepository) {
        $scope.isLoading = busy.create();
        $scope.isLoading.promise(getUrl($routeParams, octopusRepository)).then(function(path) {
          $location.path(path);
          $location.replace();
        });
      }
    };
  };

  this.$get = function() { };
});


*/



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octo_route.js
// module id = 1375090042644656
// module chunks = 1